import { gql } from '@/__generated__/gql'

export const ContentDetailsTagContentReferenceFragment = gql(`
  fragment ContentDetails_Tag_ContentReferenceFragment on ContentReference{
      id
      sortKey
      contentReferenceType{
        type
      }
      contentTo(language: ["en", "_primary"]) {
        id
        titleGroupId
        title
        contentId
        contentType
        published
      }
}
`)
